// extracted by mini-css-extract-plugin
export default {"container":"lL-z","topReviewHeading":"mL-z","criticalReview":"nL-z","favorableReview":"oL-z","vsSeparator":"pL-z"};